import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '@shared/button/button.component';
import { BrandedReportsHelpModalComponent } from '../branded-reports-help-modal/branded-reports-help-modal.component';

@Component({
  selector: 'zbp-branded-report-no-selection',
  imports: [
    ButtonComponent
  ],
  templateUrl: './branded-report-no-selection.component.html',
  styleUrl: './branded-report-no-selection.component.scss'
})
export class BrandedReportNoSelectionComponent {
  @Input() showProgressReportsHelp: boolean = false;
  @Input() noDataMessage: string = 'Please make the appropriate selections and hit apply to see the report.';
  readonly helpMenuIconName = BrandedReportsHelpModalComponent.iconName;
  constructor(private modalService: NgbModal) { }

  openHelp() {
    BrandedReportsHelpModalComponent.open(this.modalService);
  }
}
